// KIDNEY HEALTH section — all 2026 assets (Kidney Health folder + jpgs/).
import { pdf2026, thumb2026, S3 } from "./assets";

const CAT = "Kidney Health";
const card = (title, file, thumb) => ({
  title,
  pdf: pdf2026(CAT, `${file}.pdf`),
  thumb: thumb2026(`${thumb || file}.jpg`),
});

const kidneyHealthCards = [
  // NOTE: curly apostrophe in "Beginner’s" matches the actual S3 key exactly.
  card("Beginner’s Guide to Starting a Plant-Based Diet", "Beginner’s Guide to Starting a Plant-Based Diet"),
  card("How a Plant-Based Diet Is Good For Your Kidneys", "How a Plant-Based Diet Is Good For Your Kidneys"),
  card("10 Common Habits That May Harm Your Kidneys", "10 Common Habits That May Harm Your Kidneys"),
  card("5 Stages of Chronic Kidney Disease (CKD)", "5 Stages of Chronic Kidney Disease (CKD)"),
  card("Dialysis Fact Sheet", "Dialysis Fact Sheet"),
  card("Kidney Transplants", "Kidney Transplants"),
  card("Guide to Phosphorus in Food", "Guide to Phosphorus in Food"),
  // The resource file is a JPG (no PDF) and the thumbnail is "Oxalates in Food.jpg".
  {
    title: "Food and Beverages High in Oxalate",
    pdf: `${S3}/pdf/2026/${encodeURIComponent("LWC 6.4 files to download")}/Kidney%20Health/${encodeURIComponent("Foods and Beverages High in Oxalate.jpg")}`,
    thumb: thumb2026("Oxalates in Food.jpg"),
  },
];

export default kidneyHealthCards;
